import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import TetherComponent from "react-tether";

class Group extends PureComponent {
  static propTypes = {
    label: PropTypes.node,
    helpText: PropTypes.string,
    // name: PropTypes.string.isRequired,
    // errorText: PropTypes.string,
    errors: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired
      })
    ),
    fixedLabel: PropTypes.bool,
    children: PropTypes.node.isRequired,
    inputID: PropTypes.string.isRequired,
    required: PropTypes.bool,
    className: PropTypes.string.isRequired
  };

  static defaultProps = {
    label: "",
    helpText: null,
    errors: null,
    fixedLabel: false,
    required: false,
    className: ""
  };

  constructor(...args) {
    super(...args);
    this.state = {
      isHelpActive: false
    };
    this.hideHelp = this.hideHelp.bind(this);
    this.toggleHelp = this.toggleHelp.bind(this);
  }

  showHelp() {
    this.setState({ isHelpActive: true });
  }

  hideHelp() {
    this.setState({ isHelpActive: false });
  }

  toggleHelp() {
    this.setState({ isHelpActive: !this.state.isHelpActive });
  }

  render() {
    // const helpCaption =
    //   this.props.helpText && this.state.isHelpActive
    //     ? <div className="form-m__info">
    //         <div className="form-m__info-icon">
    //           <i className="fa fa-exclamation-circle" aria-hidden="true" />
    //         </div>
    //         <div className="form-m__info-text">
    //           {this.props.helpText}
    //         </div>
    //         <button onClick={this.hideHelp} className="form-m__info-close">
    //           <i className="fa fa-times" aria-hidden="true" />
    //         </button>
    //       </div>
    //     : null;

    // const helpIcon = this.props.helpText
    //   ? <button onClick={this.toggleHelp} className="form-m__note">
    //       <i className="fa fa-question-circle-o" aria-hidden="true" />
    //     </button>
    //   : null;

    let groupClassName = `${this.props.className} form-m__group`;
    groupClassName +=
      undefined !== this.props.errors && this.props.errors.length
        ? " is-error"
        : "";
    const errorElement =
      undefined !== this.props.errors && this.props.errors.length
        ? this.props.errors.map(error => (
            <div key={`${error.text}-${error.type}`} className="form-m__error">
              {error.text}
            </div>
          ))
        : null;

    const fixedLabelClass = this.props.fixedLabel ? "form-m__label--top" : "";
    return (
      <div className={groupClassName}>
        <div className="form-m__inputField">
          <div className="form-m__inputContainer">
            {this.props.children}
            <label
              className={`form-m__label ${fixedLabelClass}`}
              htmlFor={this.props.inputID}
            >
              {this.props.label}
              {this.props.required && (
                <em className="form-m__label--required">*</em>
              )}
            </label>
          </div>

          {this.props.helpText && (
            <TetherComponent
              attachment="middle left"
              // offset="0 10px"
              constraints={[
                {
                  to: "scrollParent",
                  attachment: "together"
                }
              ]}
              renderTarget={ref => (
                <button
                  ref={ref}
                  type="button"
                  onClick={this.toggleHelp}
                  className="form-m__note"
                >
                  <i className="fa fa-question-circle-o" aria-hidden="true" />
                </button>
              )}
              renderElement={ref =>
                this.props.helpText &&
                this.state.isHelpActive && (
                  <div ref={ref} className="form-m__info">
                    <div className="form-m__info-icon">
                      <i
                        className="fa fa-exclamation-circle"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="form-m__info-text">
                      {this.props.helpText}
                    </div>
                    <button
                      onClick={this.hideHelp}
                      className="form-m__info-close"
                    >
                      <i className="fa fa-times" aria-hidden="true" />
                    </button>
                  </div>
                )
              }
              style={{ zIndex: "1" }}
            />
          )}
        </div>

        {/* <span className="form-m__bar" /> */}

        {errorElement}

        {/* {helpCaption}
        {helpIcon} */}
      </div>
    );
  }
}

export default Group;



// WEBPACK FOOTER //
// ./src/components/Form/Input/Group.js